const translations = {
  please_wait: 'Please wait...',
  error: 'An error has occurred. Try again later.',
  export_generated: 'Export generated successfully',
  validation_errors: 'There are validation errors. Please check all fields before saving.',
  please_make_sure_not_duplicated: "Please make sure all required fields are filled and it's not a duplicated vehicle.",
  go_to_home: 'Go to home page',
};

export default translations;
